<template>
  <div class="box box--news">
    <div class="box-img-wrapper">
      <template v-if="news.videoURL && thumbnail">
        <img :src="thumbnail">
      </template>
      <AttachmentLoader v-else-if="news.videoURL && !thumbnail"></AttachmentLoader>
      <ImageWrapper v-else :file="news.idFile"></ImageWrapper>
    </div>
    <div class="box-inner">
      <span class="box-tag">
        <span>{{ news.date | formatDate2 }}</span>
        <span v-if="news._embedded.Content.importSource">{{news._embedded.Content.importSource}}</span>
        <span v-if="!news.videoURL">{{readTime(news.contentNew)}} minute read</span>
      </span>
      <router-link class="box-title" :to="{name: 'NewsSingle', params: {id: news.idNews}}"><span>{{news.headline}}</span></router-link>
      <div class="box-bottom">
        <a>Read more</a>
        <span class="span-icon" v-if="news.commentsCounter"><i class="icon-comment"></i> {{news.commentsCounter}}</span>
        <span class="span-icon" v-if="news.likes"><i class="icon-vote-up"></i> {{news.likes}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import ImageWrapper from "@/components/general/ImageWrapper";
import {readTime} from "@/helpers/readTime";
import AttachmentLoader from "@/components/forms/AttachmentLoader";
import vimeo from "@/api/external/vimeo";
export default {
  components: {AttachmentLoader, ImageWrapper},
  props:['news'],
  name: "NewsBox",
  data() {
    return {
      thumbnail: ''
    }
  },
  mounted() {
    if(this.news.videoURL) {
      this.getVideoThumbnail()
    }
  },
  methods: {
    readTime: readTime,
    getVideoThumbnail() {
      let yt_rx = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/;
      let matches = this.news.videoURL.match(yt_rx)
      if(matches) {
        this.setYTThumbnail(matches[5])
      }

      let vm_rx = /(https?:\/\/)?(www\.)?(player\.)?vimeo\.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/;
      if(this.news.videoURL.match(vm_rx))      {
        this.setVimeoThumbnail()
      }
    },
    setVimeoThumbnail() {
      vimeo.getThumbnail(this.news.videoURL, (response) => {
        this.thumbnail = response.thumbnail_url
      })
    },
    setYTThumbnail(videoId) {
      this.thumbnail = `https://i1.ytimg.com/vi/${videoId}/maxresdefault.jpg`
    }
  }
}
</script>

<style scoped>

</style>